enum ValidFactActions {
	IMRESSION = 'impr',
	VIEW = 'view',
	CLICK = 'clic',
	SUBMIT = 'subm'
}

enum EncodedCharacters {
	QUESTION_MARK = '%3F',
	AMPERSAND = '%26',
	COLON = '%3A',
	HASH = '%23'
}

enum UrlParametersKeys {
	TARGET = 'target',
	TARGET_PARAMS = 'target_params',
	TARGET_PATH = 'target_path',
	FACTS = 'facts',
	TAPS = 'taps',
	DUID = 'duid',
	SID = 'sid',
	UID = 'uid',
	PGL = 'pgl'
}

interface ISessionAndDomainIds {
	[UrlParametersKeys.DUID]?: string;
	[UrlParametersKeys.SID]?: string;
	[UrlParametersKeys.UID]?: string;
}

interface IUrlParameters extends ISessionAndDomainIds {
	[UrlParametersKeys.TARGET]: string;
	[UrlParametersKeys.TARGET_PARAMS]?: string | null;
	[UrlParametersKeys.TARGET_PATH]?: string | null;
	[UrlParametersKeys.FACTS]: string;
	[UrlParametersKeys.TAPS]: string | null;
	[UrlParametersKeys.PGL]?: boolean | null;
}

interface ITrackingUserDetails {
	i: string | null;
	s: string | null;
	l: string | null;
	c: string | null;
	a: string | null;
}

interface ITrackingFactLocation {
	t: string;
	i: string | number | null;
	d: string | null;
	l: string | null;
}

interface ITrackingFact {
	a: string;
	t: string;
	i: string;
	d: string;
	l: string;
	lo?: ITrackingFactLocation | null;
	ex?: any;
}

interface IStoredTrackingDetails {
	ip: string | null;
	uuid: string | null;
	lang: string | null;
	search: any;
	tap_groups: string | null;
	previousPage?: string;
}

interface ISnowplowInstance {
	getDomainUserInfo: () => string[];
	getUserId: () => string;
}

export {
	ITrackingFact,
	ITrackingFactLocation,
	ITrackingUserDetails,
	IStoredTrackingDetails,
	ISessionAndDomainIds,
	IUrlParameters,
	ISnowplowInstance,
	ValidFactActions,
	EncodedCharacters,
	UrlParametersKeys
};
